import { Col } from 'react-styled-flexboxgrid';
import styled from 'styled-components';

import { Input } from '@savgroup-front-common/core/atoms/Form';
import { mediaQuery } from '@savgroup-front-common/core/grid/helpers';
import { transparentize } from '@savgroup-front-common/primitive/helpers/cssColor';
import { spacing } from '@savgroup-front-common/primitive/helpers/spacing';

export const $Container = styled('div')`
  position: relative;
  width: 100%;
  padding: ${spacing(1.5)} ${spacing(1.5)} ${spacing(1.5)} ${spacing('md')};

  ${mediaQuery.sm`padding: 12px 20px;`};
`;

export const $LocationField = styled(Input)``;

export const $DropdownSuggestions = styled('div')`
  background-color: ${({ theme }) => theme.colors.white};
  border-style: solid;
  border-radius: ${({ theme }) => theme.tw.radius.sm};
  border-color: ${({ theme }) => theme.colors.default};
  border-width: ${({ theme }) => theme.borders.thickness};
  ${({ theme }) => theme.shadows.elevation__2};
  margin-top: ${spacing('xxs')};
  z-index: 2;
  position: absolute;
  width: 100%;
`;

export const $Suggestion = styled('div')<{ active: boolean }>`
  color: ${({ theme }) => theme.colors.mainTextColor};
  background-color: ${({ theme, active }) =>
    active ? transparentize(0.85, theme.colors.default) : theme.colors.white};
  padding: ${spacing(3.5)};
  cursor: pointer;
  &:hover {
    background-color: ${({ theme }) =>
      transparentize(0.85, theme.colors.default)};
  }
`;

export const $RowStyled = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  border: 1px solid ${({ theme }) => theme.colors.default};
  border-radius: ${({ theme }) => theme.tw.radius.sm};
  &:hover {
    border-color: ${({ theme }) => theme.colors.primary};
  }

  && input {
    border: none;
    box-shadow: none;
  }

  && button {
    & svg {
      margin-right: ${spacing('sm')};
    }

    &:hover {
      &,
      & svg {
        background: ${({ theme }) => theme.colors.white};
        color: ${({ theme }) => theme.colors.primary};
        fill: ${({ theme }) => theme.colors.primary};
      }
    }
  }
`;

export const $ColWithoutPaddingRight = styled(Col)`
  padding-right: 0;
`;
